<template>
  <j-form-container :disabled="disabled">
    <a-form :form="form" slot="detail">
      <a-row>
        <a-col :span="12">
          <a-form-item label="收入金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['incomeAmount', validatorRules.incomeAmount]" placeholder="请输入收入金额（元）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="利润金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['profitAmount', validatorRules.profitAmount]" placeholder="请输入利润金额（元）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('label.costAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['costAmount', validatorRules.costAmount]" placeholder="请输入成本金额（元）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('label.costAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['feeAmount', validatorRules.feeAmount]" placeholder="请输入费用金额（元）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('label.subsidyAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['subsidyAmount', validatorRules.subsidyAmount]" placeholder="请输入补贴金额（元）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="代养费" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['fosterFee', validatorRules.fosterFee]" placeholder="请输入代养费（元）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="甲方利润（系统）" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['paProfitSys', validatorRules.paProfitSys]" placeholder="请输入甲方利润（系统）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="甲方利润（实际）" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number  v-decorator="['paProfitAct', validatorRules.paProfitAct]" placeholder="请输入甲方利润（实际）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="乙方利润（系统）" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['pbProfitSys', validatorRules.pbProfitSys]" placeholder="请输入乙方利润（系统）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="乙方利润（实际）" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number  v-decorator="['pbProfitAct', validatorRules.pbProfitAct]" placeholder="请输入乙方利润（实际）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('label.marginBalance')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['marginBalance', validatorRules.marginBalance]" placeholder="请输入保证金余额（元）" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="最终支付金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number disabled v-decorator="['finalPayAmount', validatorRules.finalPayAmount]" placeholder="请输入最终支付金额" style="width: 84%"/> 元
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </j-form-container>
</template>
<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'

export default {
  name: 'ProfitInfoForm',
  components: {
    JFormContainer,
  },
  props:{
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      validatorRules: {
        incomeAmount: {
          rules: [
            { required: false},
          ]
        },
        costAmount: {
          rules: [
            { required: false},
          ]
        },
        feeAmount: {
          rules: [
            { required: false},
          ]
        },
        fosterFee: {
          rules: [
            { required: false},
          ]
        },
        subsidyAmount: {
          rules: [
            { required: false},
          ]
        },
        profitAmount: {
          rules: [
            { required: false},
          ]
        },
        paProfitSys: {
          rules: [
            { required: false},
          ]
        },
        paProfitAct: {
          rules: [
            { required: false},
            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
          ]
        },
        pbProfitSys: {
          rules: [
            { required: false},
          ]
        },
        pbProfitAct: {
          rules: [
            { required: false},
            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
          ]
        },
        marginBalance: {
          rules: [
            { required: false},
          ]
        },
        finalPayAmount: {
          rules: [
            { required: false},
          ]
        },
      },
      confirmLoading: false,
    }
  },
  methods:{
    initFormData(url,id){
      this.clearFormData()
      if(!id){
        this.edit({})
      }else{
        getAction(url,{id:id}).then(res=>{
          if(res.success){
            let records = res.result
            if(records && records.length>0){
              this.edit(records[0])
            }
          }
        })
      }
    },
    edit(record){
      this.model = Object.assign({}, record)
      console.log("ProfitInfoForm-edit",this.model);
      let fieldval = pick(this.model, 'incomeAmount','costAmount','feeAmount','subsidyAmount','fosterFee','profitAmount','paProfitSys','paProfitAct','pbProfitSys','pbProfitAct','marginBalance','finalPayAmount')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
    },
    getFormData(){
      let formdata_arr = []
      this.form.validateFields((err, values) => {
        if (!err) {
          let formdata = Object.assign(this.model, values)
          let isNullObj = true
          Object.keys(formdata).forEach(key=>{
            if(formdata[key]){
              isNullObj = false
            }
          })
          if(!isNullObj){
            formdata_arr.push(formdata)
          }
        }else{
          this.$emit("validateError","结算单详情表单校验未通过");
        }
      })
      console.log("结算单详情表单数据集",formdata_arr);
      return formdata_arr;
    },
    popupCallback(row){
      this.form.setFieldsValue(pick(row,'incomeAmount','costAmount','feeAmount','subsidyAmount','fosterFee','profitAmount','paProfitSys','paProfitAct','pbProfitSys','pbProfitAct','marginBalance','finalPayAmount'))
    },
    clearFormData(){
      this.form.resetFields()
      this.model={}
    },
  }
}
</script>
